// import OptionSwitch from '@jetshop/core/components/OptionSwitch';
import { useProductVariants } from '@jetshop/core/hooks/useProductVariants';
// import {useVariantFromUrl} from '@jetshop/core/hooks/useProductVariants/useVariantFromUrl';
// import { ProductVariationConsumer } from '@jetshop/core/components/ProductVariationProvider/ProductVariationContext';
import { default as Breadcrumbs } from '@jetshop/ui/Breadcrumbs';
// import { Above } from '@jetshop/ui/Breakpoints';
import { SelectDropdown } from '@jetshop/ui/Select';
import StockStatusContainer from '@jetshop/ui/Stock/StockStatusContainer';
import get from 'lodash.get';
import React from 'react';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import { Price } from '../Price';

// import AddToCartWrapper from './AddToCart/AddToCartWrapper';
import ImageContainer from './Images/ImageContainer';
import { ProductSection } from './ProductInfo';
// import NotifyWhenBack from './StockStatus/NotifyWhenBack';
// import StockStatusIndicator from './StockStatus/StockStatusIndicator';
import getParentOrCanonicalRoute from '@jetshop/ui/Breadcrumbs/getParentsOrCanonicalRoute';
import AddFavoriteButton from '../FavoriteList/AddFavoriteButton';
import RelatedProducts from './RelatedProducts';
import CrossSellProduct from './CrossSellProduct';
import ProductInfoAccordion from './ProductInfoAccordion';
import ColorVariants from './ColorVariants/ColorVariants';
import AddToCartForm from './AddToCart/AddToCartForm';

const Container = styled('div')`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 81px;
  ${({ theme }) => theme.elements.container};
  padding: 0;

  ${({ theme }) => theme.below.md} {
    display: block;
    padding: 0 ${({ theme }) => theme.sizes.gap};
  }
`;

const Heading = styled('h1')`
  font-family: ${({ theme }) => theme.fontHeading};
  font-size: 2.6rem;
  margin-bottom: 0.5rem;
`;

const SubHeading = styled('h2')`
  margin-bottom: 10px;
  font-size: 1.5rem;
  line-height: 2rem;
`;

const ShortDescription = styled('article')`
  line-height: 1.75;
  font-size: 0.875rem;
  margin-bottom: 1rem;

  p {
    margin-bottom: 1rem;
  }
`;

const ProductContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TrofeBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 0.5rem;
  li:after {
    content: '>';
  }
`;

const ProductDetailsWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ theme }) => theme.above.md} {
    align-items: flex-start;
  }

  [class*='-Wrapper'] {
    display: flex;
    margin-bottom: 2rem;

    div {
      margin-right: 12px;
    }
  }

  [class*='-Normal'] {
    font-size: 2.6rem;
    font-family: ${({ theme }) => theme.fontHeading};
  }

  [class*='-New'] {
    font-size: 2.6rem;
    color: #e34040;
  }

  [class*='-Old'] {
    color: #aaa;
  }
`;

const AttributeWrapper = styled('div')`
display: flex;
justify-content: space-between;
width: 100%;
margin-bottom: calc(${({ theme }) => theme.sizes.gap} * 2);
${({ theme }) => theme.below.md} {
  display: block
}
& > div > svg {
  display: none;
}
&.outOfStock {
  & > div:last-of-type {
    h4 {
    margin-left: 2.5rem;
    }
    & > svg {
      display: block;
      }
    }
  }
}
`;

const PickerWrapper = styled('div')`
  width: calc(50% - ${({ theme }) => theme.sizes.gap});
  button {
    background: ${({ theme }) => theme.colors.grey};
    border: none !important;
    color: ${({ theme }) => theme.colors.black} !important;
  }

  ${({ theme }) => theme.below.md} {
    width: 100%;
    flex: 1 1 auto;
    margin-bottom: 1.5rem;
  }
`;

const DefaultPicker = ({ option, error, ...props }) => {
  return (
    <PickerWrapper>
      <label>{option.name}</label>
      <SelectDropdown
        title={'Välj'}
        defaultSelectedItem={{
          value: props.items && props.items[0] && props.items[0].value
        }}
        {...props}
        data-testid={`${option.name}-select-dropdown`}
      />
    </PickerWrapper>
  );
};

const CategoryDiv = styled('div')`
  color: ${({ theme }) => theme.colors.greyMedium};
  text-transform: uppercase;
  font-size: 1rem;
  margin-bottom: -0.5rem;
  span {
    vertical-align: top;
  }
  &::before {
    content: '';
    display: inline-block;
    width: 3px;
    height: 14px;
    background: ${({ theme }) => theme.colors.pinkDark};
    position: relative;
    bottom: 0px;
    margin-right: 0.5rem;
  }
`;

const QuantityCartStockWrap = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  ${({ theme }) => theme.below.md} {
    flex-wrap: wrap;
    p {
      flex: 1 1 100%;
      margin-top: 1.25rem;
      text-align: center;
    }
  }
`;

const FavoriteButtonWrap = styled('div')`
  position: absolute;
  right: 0;
  top: 55px;
  ${({ theme }) => theme.below.md} {
    //bottom: 70px;
  }
`;

export const availableStatus = [];

export const stockStatus = () => {
  return 'status';
};

const Product = ({ result: { data, loading }, product }) => {
  const initialVariant = product.variants.values[0];
  const variantHandler = useProductVariants(product, { initialVariant });
  const {
    selectedVariant: selectedVariation,
    getMissingOptions
  } = variantHandler;

  const images = get(product, 'images', []);
  const parents = getParentOrCanonicalRoute(data?.route?.parents, product);

  const matchingProduct =
    product && product.customFields
      ? product.customFields.filter(object => {
          return object.key === 'Matchande';
        })[0]
      : null;

  const matchingProductArticleNumber = matchingProduct
    ? matchingProduct.stringValue
    : null;

  // {
  //   __typename: product.variants.__typename,
  //   articleNumber: product.articleNumber,
  //   previousPrice: product.previousPrice,
  //   price: product.price,
  //   recommendedPrice: product.recommendedPrice,
  //   stockStatus: product.stockStatus,
  //   values: product.variants.values[0]
  // }

  return product ? (
    <StockStatusContainer product={selectedVariation || product}>
      {stockStatus => (
        <ProductContainer>
          <MaxWidth>
            <TrofeBreadcrumbs
              parents={parents}
              breadcrumbText={product.breadcrumbText}
            />
          </MaxWidth>
          <Container>
            <ProductSection>
              <ImageContainer images={images} badges={product.badges} />
              <FavoriteButtonWrap>
                <AddFavoriteButton product={product} />
              </FavoriteButtonWrap>
            </ProductSection>
            <ProductSection>
              <ProductDetailsWrapper>
                <Heading data-testid="product-title">
                  {product.mainHeader || product.name || 'Loading...'}
                </Heading>
                {data.route && data.route.parents.length > 0 && (
                  <CategoryDiv>
                    <span>{data.route.parents[0].object.breadcrumbText}</span>
                  </CategoryDiv>
                )}
                <SubHeading>{product.subName}</SubHeading>
                <ShortDescription
                  dangerouslySetInnerHTML={{
                    __html: product.shortDescription
                  }}
                />
                <Price
                  previousPrice={(selectedVariation || product).previousPrice}
                  price={(selectedVariation || product).price}
                />

                <ColorVariants product={product} />

                <AddToCartForm
                  product={product}
                  variant={selectedVariation}
                  getMissingOptions={getMissingOptions}
                  variantHandler={variantHandler}
                />

                <ProductInfoAccordion product={product} />
              </ProductDetailsWrapper>
            </ProductSection>

            {/*<Above breakpoint="md">*/}
            {/*{matches =>*/}
            {/*matches ? (*/}
            {/*<ProductInfo product={product} />*/}
            {/*) : (*/}
            {/*<ProductInfo product={product} />*/}
            {/*//<ProductInfoAccordion product={product} />*/}
            {/*)*/}
            {/*}*/}
            {/*</Above>*/}

            {matchingProductArticleNumber && (
              <CrossSellProduct
                productArticleNumber={matchingProductArticleNumber}
              />
            )}

            <RelatedProducts relatedProducts={product.relatedProducts} />
          </Container>
        </ProductContainer>
      )}
    </StockStatusContainer>
  ) : null;
};

export default Product;
